import React, { Component } from 'react';
import { Form} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Header extends Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                
                        <Form className="p-3">
                        <div className="form-section">
                                <h1>Candidate Satisfaction Survey</h1>
                        </div>
                        </Form>
                    
                </Div>
            </ThemeProvider>
        )
    }
}

export default Header;